import server from '../../api/server';

export class CreateUserConsultPhotoService {
    static async createConsultPhoto(token: string, data: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        };

        try {
            const responseServer = await server.post(
              `staff/consult-photos`,
              JSON.stringify(data),
              {headers}
            );

            if (responseServer.data.statusCode != 200) {
                console.log("ERROR");
            }

            return responseServer.data.data;
        } catch (error: any) {
            throw new Error(error.response.status);
        }
    }
}
